import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { RouterModule } from "@angular/router";
import { MaterialModule } from "src/app/material.module";
import { SharedModule } from "src/app/shared.module";
import { UserNavSettingsComponent } from "./user-nav-settings.component";

@NgModule({
    imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule,
    MaterialModule,
    SharedModule,
],
    declarations: [UserNavSettingsComponent],
    exports: [UserNavSettingsComponent]
})
export class UserNavSettingsModule {}